import { Outlet } from 'react-router-dom'

import { DisplayFontsLoader } from '@/components/shared/DisplayFontsLoader'

/** Mirrors layouts/TestResultsLayout/TestResultsLayout.tsx */
export function SpaResultsLayout() {
  return (
    <>
      <DisplayFontsLoader />
      <Outlet />
    </>
  )
}
